import type { DisplayStore, SearchStore, StoreSearchParams, StoreV2, WebStore } from '@libs/common-types';
import { CWEA_ENDPOINTS } from '../constants';
import { cweaClient } from '../clients/api-proxy-browser-client';

export async function getStoreById(storeId: string) {
    const url = CWEA_ENDPOINTS.stores.getStoreById(storeId);
    return await cweaClient.get<StoreV2>(url);
}

export async function getWebStoreById() {
    const url = CWEA_ENDPOINTS.stores.getWebStoreById();
    return await cweaClient.get<WebStore>(url);
}

export async function getDisplayStoreById(storeId: string) {
    const url = CWEA_ENDPOINTS.stores.getDisplayStoreById(storeId);
    return await cweaClient.get<DisplayStore>(url);
}

export async function searchStores(params: StoreSearchParams) {
    const url = CWEA_ENDPOINTS.stores.search(params);
    return await cweaClient.get<SearchStore[]>(url);
}
